import React, { Component } from 'react'
import View from './view'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import './style.css'
import ArrowIcon from '../../components/Icons/ArrowDown'
import { isAllowed, REPORTS, ADMIN } from '../../util'

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}


const subNavBarItems = [
  {
    role: [REPORTS],
    label: "العجلات",
    subNav: [
      { label: "كشف مفصل", url: "cars/report", role: [REPORTS] },
      { label: "تقرير العمليات", url: "cars/access", role: [ADMIN] },
    ]
  },
  // {
  //   role: [ADMIN],
  //   label: "المبيعات",
  //   subNav: [
  //     { label: "المندوبين", url: "sales/salesman", role: [ADMIN] },
  //     { label: "القوائم المرفوضة", url: "sales/refused", role: [ADMIN] },
  //   ]
  // },
]


class index extends Component {

  constructor(props) {
    super(props)
    this.state = {

    }
  }
  goto = link => () => {
    let { history } = this.props;
    history.push(`/reports/${link}`)
  }

  createNavBarItems = (items) => {
    let { user } = this.props
    return items.filter(i => isAllowed(user.user, i.role))
      .map((i, index) => <span key={index} className="flex justify-between parent w-1/8 relative mx-1" style={{ lineHeight: "50px" }}><span className="cursor-pointer mx-1" >{i.label}</span><ArrowIcon />
        <ul className="submenu bg-white absolute" style={{ top: "50px" }}>
          {this.createSubNavBarItems(i.subNav.filter(e => isAllowed(user.user, e.role)))}
        </ul>
      </span>)
  }

  createSubNavBarItems = (items) => {
    return items.map((s, index) =>
      <li key={index}> <span onClick={this.goto(s.url)} className="w-32 block cursor-pointer mx-2">{s.label}</span> </li>
    )

  }

  render() {
    let items = this.createNavBarItems(subNavBarItems)
    return (
      <View
        items={items}
      />
    )
  }
}


export default withRouter(connect(mapStateToProps)(index))


